import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { HttpService } from "../../../service/HttpService";
import dayjs from "dayjs";

const handleDownloadHistoryExcel = async (
  id,
  setShowLoginPopup,
  startDate,
  endDate
) => {
  const httpService = new HttpService(setShowLoginPopup);

  const fetchHistoryData = () => {
    return new Promise((resolve, reject) => {
      httpService
        .get(
          `inventory/transactions/${id}?start_date=${startDate}&end_date=${endDate}`
        )
        .then((response) => {
          if (response?.data) {
            resolve(response?.data);
          } else {
            reject(new Error("No data found"));
          }
        })
        .catch((error) => {
          console.error("Error fetching history data:", error);
          reject(error);
        });
    });
  };

  try {
    const { inventory, history } = await fetchHistoryData();

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("HistoryData");
    worksheet.addRow(["Inventory Details"]);
    worksheet.mergeCells("A1:C1");
    worksheet.getCell("A1").font = { bold: true, size: 14 };
    worksheet.getCell("A1").alignment = { horizontal: "center" };
    worksheet.addRow([]);
    worksheet.addRow(["Item Name", inventory[0]?.item_name || ""]);
    worksheet.addRow(["Stored Location", inventory[0]?.stored_location || ""]);
    // worksheet.addRow([
    //   "Reorder Amount",
    //   inventory[0]?.reorder_amount
    //     ? parseFloat(inventory[0]?.reorder_amount)
    //     : 0,
    // ]);
    // worksheet.addRow([
    //   "Reorder Threshold",
    //   inventory[0]?.reorder_threshold
    //     ? parseFloat(inventory[0]?.reorder_threshold)
    //     : 0,
    // ]);
    // worksheet.addRow([
    //   "On Hand Qty",
    //   inventory[0]?.on_hand_qty ? parseFloat(inventory[0]?.on_hand_qty) : 0,
    // ]);
    worksheet.addRow(["Department", inventory[0]?.department_name || ""]);
    worksheet.addRow([]);
    const currentRow = worksheet.lastRow.number + 1;
    worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
    const titleCell = worksheet.getCell(`A${currentRow}`);
    titleCell.value = `History : ${inventory[0]?.item_name || ""}`;
    titleCell.alignment = { horizontal: "center" };
    titleCell.font = { bold: true, size: 14 };
    worksheet.addRow([]);
    worksheet.addRow(["Date", "Purchased Qty", "Used Qty"]);
    worksheet.getRow(worksheet.lastRow.number).alignment = {
      horizontal: "center",
    };

    // ===== History Data =====
    if (history && history.length > 0) {
      history.forEach((entry) => {
        worksheet.addRow([
          dayjs(entry?.date).format("DD/MM/YYYY") || "",
          entry?.purchased_qty ? parseFloat(entry.purchased_qty) : 0,
          entry?.used_qty ? parseFloat(entry.used_qty) : 0,
        ]);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const formattedDate = moment().format("MM-DD-YYYY_hh-mm-ss_A");

    saveAs(new Blob([buffer]), `HistoryData_${formattedDate}.xlsx`);
  } catch (error) {
    console.error("Error downloading history Excel:", error);
  }
};

export { handleDownloadHistoryExcel };
